




































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Utilities as utils } from '@/shared/utilities';

@Component({
  components: {},
})
export default class RowItem extends Vue {
  @Prop() years: any;
  @Prop() yrIndex: any;
  @Prop() result: any;
  @Prop() yr: any;
  @Prop() deliverable: any;
  @Prop() activity: any;
  @Prop() resIndex: any;
  @Prop() delIndex: any;
  @Prop() actIndex: any;
  @Prop() model: any;
  @Prop() readonly: any;
  @Prop() timeFrame: any;
  // @Prop() timeSlot;
  // @Prop() timeIndex;

  /** Get the checked status of the checkbox */
  checkedStatus(resultId, deliverableId, activityId, year, frame) {
    return utils.getNestedValue(this.model, `${resultId}.${deliverableId}.${activityId}.${year}.${frame}`);
  }

  /** update the status */
  updateStatus(resultId, deliverableId, activityId, year, frame, status) {
    utils.setValue(`${resultId}.${deliverableId}.${activityId}.${year}.${frame}`, status, this.model);
    this.$emit('change', status);
  }

  calcRowspan(data: any) {
    let lng = 0;
    if (data && data.deliverables && data.deliverables.length > 0) {
      data.deliverables.map((x) => {
        lng += x.activities.length;
      });
    }
    return lng;
  }
}
